import type {SelectOption} from 'shells/select-picker-inline-text/select-picker-inline-text';

export const VIEWS = {
    YOUR_WEBSITE_VIEW: 'your-website',
    INTERACTIVE_PREVIEW_VIEW: 'interactive-preview',
    EMBED_CHATBOT_VIEW: 'embed-chatbot',
} as const;

export type ChatOnboardingView = (typeof VIEWS)[keyof typeof VIEWS];

export const ANIMATION_SRC = {
    YOUR_WEBSITE: '/include/rive/chatbot-onboarding/step-1-your-website.riv',
    CRAWLING_STATE: '/include/rive/chatbot-onboarding/step-2-crawling-state.riv',
    EMBED_CHATBOT: '/include/rive/chatbot-onboarding/step-3-embed-chatbot.riv',
} as const;

export const SUB_PAGE_LIMIT = 10;

export const ERROR_MESSAGE_CRAWLING =
    'There was an error crawling your website. Please verify you have entered the correct domain and try again.';

export const PROTOCOL_OPTIONS: Array<SelectOption> = [
    {
        value: 'https://',
        label: 'https://',
    },
    {
        value: 'http://',
        label: 'http://',
    },
];
